import React from "react";
import { Link, useLocation } from "react-router-dom";
import { CalendarCheck } from "lucide-react";

/**
 * Floating call-to-action: only Book Online button.
 * Phone/call icon replaced by the Chatway live chat widget (see public/index.html).
 * The Chatway widget renders its own floating bubble in the bottom-right.
 */
export default function FloatingCTAs() {
  const loc = useLocation();
  if (loc.pathname.startsWith("/admin")) return null;
  return (
    <div className="fixed bottom-5 left-5 z-40 flex flex-col gap-3" data-testid="floating-ctas">
      <Link
        to="/book"
        className="bg-[#9B1B30] hover:bg-[#7A1526] text-white w-14 h-14 rounded-full flex items-center justify-center shadow-2xl transition-all hover:scale-105 pulse-red"
        aria-label="Book online"
        data-testid="floating-book"
      >
        <CalendarCheck size={22} />
      </Link>
    </div>
  );
}
